<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in" *ngIf="formData">
  <div class="relative w-full max-w-4xl bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 flex flex-col max-h-[90vh] animate-fade-in-up">

    <div *ngIf="isLoading()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">fact_check</span>
          {{ configId ? 'แก้ไขการตั้งค่าอนุมัติ' : 'สร้างการตั้งค่าอนุมัติ' }}
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          กำหนดเมนู จำนวนชั้น และผู้อนุมัติแต่ละขั้นตอน
        </p>
      </div>
      <button type="button" (click)="onClose()" [disabled]="isLoading()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-6 md:px-8 py-6 custom-scrollbar">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">
        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
            ชื่อ Config <span class="text-rose-500">*</span>
          </label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">label</span>
            <input [(ngModel)]="formData.name" [disabled]="isLoading()"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none">
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
            เมนู <span class="text-rose-500">*</span>
          </label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">menu</span>
            <select [(ngModel)]="formData.menuListId" [disabled]="isLoading()"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none">
              <option [ngValue]="0">-- เลือกเมนู --</option>
              <option *ngFor="let menu of menuOptions" [ngValue]="menu.id">{{ menu.name }}</option>
            </select>
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">Trigger</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">bolt</span>
            <select [(ngModel)]="formData.triggerOn" [disabled]="isLoading()"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none">
              <option *ngFor="let t of triggerOptions" [value]="t.value">{{ t.label }}</option>
            </select>
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">จำนวนชั้นสูงสุด (1-3)</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">layers</span>
            <input type="number" min="1" max="3" [(ngModel)]="formData.maxLevelCount" (ngModelChange)="onMaxLevelChange()" [disabled]="isLoading()"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none">
          </div>
        </div>

        <div class="flex items-center">
          <label class="inline-flex items-center gap-3 cursor-pointer select-none">
            <input type="checkbox" id="enable" [(ngModel)]="formData.enable" [disabled]="isLoading()"
              class="w-5 h-5 rounded border-slate-300 text-amber-500 focus:ring-amber-200">
            <span class="text-sm font-bold text-slate-700 dark:text-slate-200">เปิดใช้งาน</span>
          </label>
        </div>

        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">คำอธิบาย</label>
          <div class="relative flex items-start bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200">
            <span class="absolute left-3 top-3 material-icons text-slate-400 text-lg pointer-events-none">notes</span>
            <textarea [(ngModel)]="formData.description" rows="2" [disabled]="isLoading()"
              class="w-full pl-10 pr-4 py-3 bg-transparent border-none text-sm font-medium focus:outline-none resize-none"></textarea>
          </div>
        </div>
      </div>

      <div class="space-y-4 mb-6">
        <h4 class="font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500 text-[20px]">stairs</span>
          ขั้นตอนอนุมัติ
        </h4>
        <div *ngFor="let step of formData.steps"
          class="p-4 rounded-2xl border border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-800/30 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="md:col-span-2 flex items-center gap-2">
            <span class="inline-flex items-center justify-center w-8 h-8 rounded-xl bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 text-sm font-black">
              {{ step.stepNumber }}
            </span>
            <span class="font-bold text-slate-700 dark:text-slate-200">ชั้นที่ {{ step.stepNumber }}</span>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อขั้น</label>
            <input [(ngModel)]="step.stepName" [disabled]="isLoading()"
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ประเภทผู้อนุมัติ</label>
            <select [(ngModel)]="step.approverType" (ngModelChange)="onApproverTypeChange(step)" [disabled]="isLoading()"
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
              <option *ngFor="let t of approverTypes" [value]="t.value">{{ t.label }}</option>
            </select>
          </div>
          <div *ngIf="step.approverType === 'role'">
            <app-pss-searchable-picker
              label="Role"
              icon="badge"
              placeholder="ค้นหา Role..."
              [required]="true"
              [disabled]="isLoading()"
              [selectedId]="stepPickerId(step, 'role')"
              [displayText]="stepPickerLabel(step, 'role')"
              [options]="pickerOptions()"
              [total]="pickerTotal()"
              [loading]="pickerLoading()"
              (opened)="onPickerOpened(stepPickerKey(step.stepNumber, 'role'))"
              (searchChange)="onPickerSearch(stepPickerKey(step.stepNumber, 'role'), $event)"
              (optionSelected)="onPickerSelected(stepPickerKey(step.stepNumber, 'role'), $event)"
              (cleared)="onPickerCleared(stepPickerKey(step.stepNumber, 'role'))">
            </app-pss-searchable-picker>
          </div>
          <div *ngIf="step.approverType === 'user'">
            <app-pss-searchable-picker
              label="ผู้ใช้"
              icon="person"
              placeholder="ค้นหาชื่อ login..."
              [required]="true"
              [disabled]="isLoading()"
              [selectedId]="stepPickerId(step, 'user')"
              [displayText]="stepPickerLabel(step, 'user')"
              [options]="pickerOptions()"
              [total]="pickerTotal()"
              [loading]="pickerLoading()"
              (opened)="onPickerOpened(stepPickerKey(step.stepNumber, 'user'))"
              (searchChange)="onPickerSearch(stepPickerKey(step.stepNumber, 'user'), $event)"
              (optionSelected)="onPickerSelected(stepPickerKey(step.stepNumber, 'user'), $event)"
              (cleared)="onPickerCleared(stepPickerKey(step.stepNumber, 'user'))">
            </app-pss-searchable-picker>
          </div>
          <div *ngIf="step.approverType === 'department'">
            <app-pss-searchable-picker
              label="แผนก"
              icon="apartment"
              placeholder="ค้นหาชื่อแผนก..."
              [required]="true"
              [disabled]="isLoading()"
              [selectedId]="stepPickerId(step, 'department')"
              [displayText]="stepPickerLabel(step, 'department')"
              [options]="pickerOptions()"
              [total]="pickerTotal()"
              [loading]="pickerLoading()"
              (opened)="onPickerOpened(stepPickerKey(step.stepNumber, 'department'))"
              (searchChange)="onPickerSearch(stepPickerKey(step.stepNumber, 'department'), $event)"
              (optionSelected)="onPickerSelected(stepPickerKey(step.stepNumber, 'department'), $event)"
              (cleared)="onPickerCleared(stepPickerKey(step.stepNumber, 'department'))">
            </app-pss-searchable-picker>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">โหมดชั้นถัดไป</label>
            <select [(ngModel)]="step.nextApproverMode" [disabled]="isLoading()"
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
              <option *ngFor="let m of nextModes" [value]="m.value">{{ m.label }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="space-y-3 mb-2" *ngIf="showApproverPool">
        <div class="flex items-center justify-between">
          <h4 class="font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500 text-[20px]">group</span>
            Pool ผู้อนุมัติ (เลือกคนถัดไป)
          </h4>
          <button type="button" (click)="addApprover()" [disabled]="isLoading()"
            class="px-3 py-1.5 rounded-xl text-xs font-bold text-amber-700 bg-amber-50 dark:bg-amber-900/30 hover:bg-amber-100 transition-colors disabled:opacity-50">
            + เพิ่ม
          </button>
        </div>
        <div *ngFor="let pool of formData.approvers; let i = index"
          class="p-4 rounded-2xl border border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-800/30 space-y-3">
          <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จากชั้น</label>
              <input type="number" min="1" [(ngModel)]="pool.fromStepNumber" [disabled]="isLoading()"
                class="w-full h-[46px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ไปชั้น</label>
              <input type="number" min="1" [(ngModel)]="pool.forStepNumber" [disabled]="isLoading()"
                class="w-full h-[46px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ประเภท</label>
              <select [ngModel]="poolKind(pool)" (ngModelChange)="onPoolKindChange(pool, $event)" [disabled]="isLoading()"
                class="w-full h-[46px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
                <option *ngFor="let t of approverTypes" [value]="t.value">{{ t.label }}</option>
              </select>
            </div>
            <div class="flex items-end">
              <button type="button" (click)="removeApprover(i)" [disabled]="isLoading()"
                class="w-full h-[46px] rounded-xl border border-rose-200 dark:border-rose-900/40 text-rose-600 dark:text-rose-400 text-sm font-bold hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-colors disabled:opacity-50">
                ลบ
              </button>
            </div>
          </div>
          <div *ngIf="poolKind(pool) === 'role'">
            <app-pss-searchable-picker
              label="Role"
              icon="badge"
              placeholder="ค้นหา Role..."
              [required]="true"
              [disabled]="isLoading()"
              [selectedId]="poolPickerId(pool, 'role')"
              [displayText]="poolPickerLabel(pool, 'role')"
              [options]="pickerOptions()"
              [total]="pickerTotal()"
              [loading]="pickerLoading()"
              (opened)="onPickerOpened(poolPickerKey(i, 'role'))"
              (searchChange)="onPickerSearch(poolPickerKey(i, 'role'), $event)"
              (optionSelected)="onPickerSelected(poolPickerKey(i, 'role'), $event)"
              (cleared)="onPickerCleared(poolPickerKey(i, 'role'))">
            </app-pss-searchable-picker>
          </div>
          <div *ngIf="poolKind(pool) === 'user'">
            <app-pss-searchable-picker
              label="ผู้ใช้"
              icon="person"
              placeholder="ค้นหาชื่อ login..."
              [required]="true"
              [disabled]="isLoading()"
              [selectedId]="poolPickerId(pool, 'user')"
              [displayText]="poolPickerLabel(pool, 'user')"
              [options]="pickerOptions()"
              [total]="pickerTotal()"
              [loading]="pickerLoading()"
              (opened)="onPickerOpened(poolPickerKey(i, 'user'))"
              (searchChange)="onPickerSearch(poolPickerKey(i, 'user'), $event)"
              (optionSelected)="onPickerSelected(poolPickerKey(i, 'user'), $event)"
              (cleared)="onPickerCleared(poolPickerKey(i, 'user'))">
            </app-pss-searchable-picker>
          </div>
          <div *ngIf="poolKind(pool) === 'department'">
            <app-pss-searchable-picker
              label="แผนก"
              icon="apartment"
              placeholder="ค้นหาชื่อแผนก..."
              [required]="true"
              [disabled]="isLoading()"
              [selectedId]="poolPickerId(pool, 'department')"
              [displayText]="poolPickerLabel(pool, 'department')"
              [options]="pickerOptions()"
              [total]="pickerTotal()"
              [loading]="pickerLoading()"
              (opened)="onPickerOpened(poolPickerKey(i, 'department'))"
              (searchChange)="onPickerSearch(poolPickerKey(i, 'department'), $event)"
              (optionSelected)="onPickerSelected(poolPickerKey(i, 'department'), $event)"
              (cleared)="onPickerCleared(poolPickerKey(i, 'department'))">
            </app-pss-searchable-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-between gap-3 bg-white/95 dark:bg-slate-900/95">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isLoading()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 transition-colors disabled:opacity-50 inline-flex items-center gap-2 cursor-pointer">
        <span class="material-icons text-base">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-col sm:flex-row justify-end gap-3 ml-auto">
        <button type="button" (click)="onClose()" [disabled]="isLoading()"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
          ยกเลิก
        </button>
        <button type="button" (click)="onSave()" [disabled]="isLoading()"
          class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-amber-900/30 transition-all disabled:opacity-50">
          {{ isLoading() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && configId"
  [entityType]="activityEntityTypes.ApprovalConfig"
  [entityId]="configId"
  title="ประวัติตั้งค่าอนุมัติ"
  [subtitle]="'#' + configId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
